"use client";
import React, { useEffect } from 'react';
import './HomeScreen.css';
import { SinisterTypes, Header, Loader } from '../../components';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useSiniestrosStore from '../../store/siniestrosStore';
import { getToken, removeToken, setSinisterTypeLocal, } from '../../utils/claimManager';
import Footer from '../../components/Footer/Footer';
import FAQ from '../../components/FAQ/FAQ';
import ClaimInformation from '../../components/ClaimInformation/ClaimInformation';
import { isset, scrollToTop, showModal } from '../../utils/functions';

const HomeScreen = ({ }) => {
	const { config, getInstance } = useSiniestrosStore();
	const navigate = useNavigate();
	const [sinisterType, setSinisterType] = useState('');
	const token = getToken();
	const [error, setError] = useState(false);

	useEffect(() => {
		if (isset(sinisterType) && sinisterType !== '') {
			const anchor = document.getElementById("anchor_documentacion");
			if (anchor) {
				const rect = anchor.getBoundingClientRect();
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

				const top = rect.top + scrollTop - (window.innerHeight / 2) + (rect.height / 2);

				window.scrollTo({
					top,
					behavior: "smooth"
				});
			}
		}
	}, [sinisterType]);

	useEffect(() => {
		(async () => {
			if (token) {
				const instance = await getInstance(token);

				if (instance && instance.step) {
					if (instance?.step !== null) {

						const response = await showModal('', 'Posee un reclamo iniciado. ¿Desea continuarlo?', '', {
							showCancelButton: true,
							cancelButtonText: 'Iniciar uno nuevo',
							confirmButtonColor: '#7C1338',
							confirmButtonText: 'Continuar con el reclamo'
						});

						if (response.isConfirmed) {
							navigate(`/stepper/${instance.step}`);
						} else {
							removeToken();
						}
					}
				}
			}
		})();
	}, [config, token]);

	const handleInitClaim = () => {
		scrollToTop();

		if (sinisterType === '' || sinisterType === null || sinisterType === undefined) {
			setError(true)
			return;
		}

		setSinisterTypeLocal(sinisterType);
		navigate('/stepper/0');
	}

	return (
		<div className='homescreen w-full items-center justify-center bg-white'>
			<Header />
			<div className='text-center w-full md:max-w-[90%] mx-auto items-center my-7 px-5 md:px-0'>
				<div className='xl:text-4xl text-3xl text-center m-auto text-red font-medium'>
					¿Qué tipo de siniestro tuviste con un asegurado de ATM Seguros?
				</div>
				<div className='xl:text-2xl md:text-xl text-black text-center font-light mt-7 lg:w-2/4 md:w-[70%] m-auto'>
					Selecciona lo que corresponda y te contamos que
					información vamos a necesitar para avanzar con el reclamo.
				</div>
			</div>
			<SinisterTypes setSinisterType={setSinisterType} />
			<div className='w-11/12 m-auto'>
				{error && (
					<p className="text-pink text-sm text-center mb-4">Debes seleccionar un tipo de siniestro.</p>
				)}
				{(sinisterType || sinisterType === 0) && (
					<ClaimInformation sinisterType={sinisterType} handleInitClaim={handleInitClaim} />
				)}
				<div className='w-10/12 mx-auto mt-20'>
					<div className='xl:text-3xl text-2xl text-center m-auto text-red font-medium mb-5'>
						Preguntas Frecuentes
					</div>
					<FAQ />
				</div>
			</div>
			<Footer />
		</div>
	);
};


export default HomeScreen;